import axios from "axios";
import ingrooveApi from "../services/ingroove/api";

const BASE_URL = 'https://api.ingroove.co.za';// process.env.REACT_APP_INGROOVE_API_URL;

const TOKEN_KEY = "omnyx_token";
const REFRESH_KEY = "omnyx_refresh";
const USER_KEY = "omnyx_user";

export const adminLogin = async (email, password) => {
  const response = await ingrooveApi.post("Authentication/adminLogin", {
    email,
    password,
  });
  return response.data;
};

export const saveAuth = (authData) => {
  localStorage.setItem(TOKEN_KEY, authData.accessToken);
  localStorage.setItem(REFRESH_KEY, authData.refreshToken);
  localStorage.setItem(USER_KEY, JSON.stringify(authData.user));
};

export const clearAuth = () => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(REFRESH_KEY);
  localStorage.removeItem(USER_KEY);
};

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const getRefreshToken = () => localStorage.getItem(REFRESH_KEY);
export const getUser = () => {
  try {
    const raw = localStorage.getItem(USER_KEY);
    if (!raw || raw === "undefined" || raw === "[object Object]") return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
};
